import { useTranslation } from 'react-i18next';

const ABOUT_IMG =
  'https://readdy.ai/api/search-image?query=Minimal%20workspace%20with%20a%20laptop%20showing%20an%20organized%20product%20spreadsheet%20table%20next%20to%20a%20notebook%20and%20a%20cup%20of%20coffee%20warm%20cream%20and%20sage%20green%20tones%20soft%20natural%20light%20clean%20editorial%20photography%20fresh%20minimal%20aesthetic&width=1200&height=900&seq=basetao-about-01&orientation=landscape';

export default function AboutSection() {
  const { t } = useTranslation();

  const listItems = ['about.list1', 'about.list2', 'about.list3'];

  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="order-2 lg:order-1">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-primary-600 mb-3">
              {t('about.eyebrow')}
            </p>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-5">
              {t('about.title')}
            </h2>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              {t('about.body1')}
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              {t('about.body2')}
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
              {t('about.body3')}
            </p>
            <ul className="space-y-3">
              {listItems.map((key) => (
                <li key={key} className="flex items-center gap-3 text-sm text-foreground-800">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                    <i className="ri-check-line text-xs" />
                  </span>
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative w-full h-[260px] md:h-[360px] rounded-lg overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Basetao spreadsheet workspace"
                title="Basetao spreadsheet resource"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}